const {
  isDev,
} = require('./utils')

/**
 * Makes a URL following the Reach conventions, taking into account localhost,
 * dev and production environments.
 *
 * @param {string} path - The path to append to the domain
 * @param {Object} params - URL modifiers
 * @param {boolean} params.isConsole - Whether to create a Console URL, default `false`
 * @param {boolean} params.isConnect - Whether to create a connect.reach.me URL, default `false`
 * @param {boolean} params.isJoin - Whether to create a join.reach.me URL, default `false`
 * @param {boolean} params.isLaunch - Whether to create a launch.reach.me URL, default `false`
 * @param {boolean} params.excludeProtocol - Whether to exclude the https:// prefix, default `false`
 * @returns {string} The full Reach URL like https://reach.me/username/live
 */
exports.makeReachUrl = (path = '', {
  isConsole,
  isConnect,
  isJoin,
  isCampaign,
  isLaunch,
  isOpen,
  isPayments,
  isDashboard,
  isReports,
  isAgent,
  isApp,
  excludeProtocol,
  avoidLocalhost,
  useReachCreatorsDomain,
} = {}) => {
  let isLocal = false
  if (!isLaunch && !isOpen && !avoidLocalhost) {
    try {
      isLocal = location.hostname === 'localhost' || location.hostname === '127.0.0.1'
    } catch (_) {
      // location undefined (server environment)
    }
  }

  let protocol = ''
  let subdomain = ''
  let pathPrefix = ''
  let domain = ''
  let domainSuffix = ''

  if (isLocal) {
    domain = 'localhost:8080'

    if (!excludeProtocol) protocol = 'http://'

    if (isConsole) pathPrefix = 'console/'
    else if (isConnect) pathPrefix = 'connect/'
    else if (isJoin) pathPrefix = 'join/'
    else if (isCampaign) pathPrefix = 'campaign/'
    else if (isPayments) pathPrefix = 'payments/'
    else if (isDashboard) pathPrefix = 'dashboard/'
    else if (isReports) pathPrefix = 'reports/'
    else if (isAgent)  pathPrefix = 'agent/'
    else if (isApp) pathPrefix = 'app/'
  } else {
    if (useReachCreatorsDomain && !isDev) {
      domain = 'reach-creators'
      domainSuffix = '.com'
    } else {
      domain = 'reach'
      domainSuffix = isDev ? '-dev.me' : '.me'
    }

    if (!excludeProtocol) protocol = 'https://'

    if (isConsole) subdomain = 'console.'
    else if (isConnect) subdomain = 'connect.'
    else if (isJoin) subdomain = 'join.'
    else if (isCampaign) subdomain = 'campaign.'
    else if (isLaunch) subdomain = 'launch.'
    else if (isOpen) subdomain = 'open.'
    else if (isPayments) subdomain = 'payments.'
    else if (isDashboard) subdomain = 'dashboard.'
    else if (isReports) subdomain = 'reports.'
    else if (isAgent) subdomain = 'agent.'
    else if (isApp) subdomain = 'app.'
  }

  const normalizedPath = path.split('/').filter(p => p).join('/') // removes leading slashes, trailing slashes, and duplicate slashes

  return `${protocol}${subdomain}${domain}${domainSuffix}/${pathPrefix}${normalizedPath}`
}
